import { MessageBox } from 'element-ui'

let lastTime = new Date().getTime();
let currentTime = new Date().getTime();
let timeOut = 24 * 60 * 60 * 1000; //设置超时时间： 24小时
// let timeOut = 10 * 60 * 1000; //设置超时时间： 10分

let timeOutInterval = null;

window.onload = function () {
    window.document.onmousedown = function () {
        sessionStorage.setItem("lastTime", new Date().getTime());
    }
};
function clearIntervals() {
    window.sessionStorage.clear();
    if (timeOutInterval) {
        clearInterval(timeOutInterval);
        timeOutInterval = null;
    }
    let timer = window.timer;
    if (timer) {
        clearInterval(timer);
        window.timer = null;
    }
    let queryTimer = window.queryTimer;
    if (queryTimer) {
        clearInterval(queryTimer);
        window.queryTimer = null;
    }
    let statisicsTimer = window.statisicsTimer;
    if (statisicsTimer) {
        clearInterval(statisicsTimer);
        window.statisicsTimer = null;
    }
    let queryTaskPlanTimer = window.queryTaskPlanTimer;
    if (queryTaskPlanTimer) {
        clearInterval(queryTaskPlanTimer);
        window.queryTaskPlanTimer = null;
    }
}

function checkTimeout() {
    currentTime = new Date().getTime(); //更新当前时间
    let tokenId = sessionStorage.getItem("tokenId");
    if (null === tokenId) {
        clearIntervals();
        return;
    }
    lastTime = sessionStorage.getItem("lastTime");
    if (currentTime - lastTime > timeOut) { //判断是否超时
        clearIntervals();
        var url = window.location.href;
        var newUrl = url.match(/(\S*)#/)[1];
        let tips = "<i class='el-icon-warn-tip'></i>长时间无操作，请重新登录";
        MessageBox.confirm(tips, '提示', {
            confirmButtonText: "好的",
            // customClass: "confirmClass-style",
            customClass: "customClass-style",
            iconClass: "",
            // confirmButtonClass: "confirm",
            confirmButtonClass: "confirm-style",
            dangerouslyUseHTMLString: true,
            showCancelButton: false,
        }).then(async () => {
            window.open(newUrl + '#/login', '_self');
        }).catch(() => {
            window.open(newUrl + '#/login', '_self');
        });
    }
}

/**
 *  定时器 间隔30秒检测是否长时间未操作页面 
 * */
timeOutInterval = window.setInterval(checkTimeout, 30000);

function setTimeOutInterval() {
    if (!timeOutInterval) {
        timeOutInterval = window.setInterval(checkTimeout, 30000);
    }
}
export { setTimeOutInterval };


// WEBPACK FOOTER //
// ./src/assets/js/loginInfo.js